import React, { useState, useEffect } from "react";

const emojiArr = [
    {
        "emoji": "😄",
        "title": "smile"
    },
    {
        "emoji": "😃",
        "title": "smiley"
    },
    {
        "emoji": "😀",
        "title": "grinning"
    },
    {
        "emoji": "😊",
        "title": "blush"
    },
    {
        "emoji": "😉",
        "title": "wink"
    },
    {
        "emoji": "😍",
        "title": "heart_eyes"
    },
    {
        "emoji": "😘",
        "title": "kissing_heart"
    },
    {
        "emoji": "😚",
        "title": "kissing_closed_eyes"
    },
    {
        "emoji": "😗",
        "title": "kissing"
    },
    {
        "emoji": "😙",
        "title": "kissing_smiling_eyes"
    },
    {
        "emoji": "😜",
        "title": "stuck_out_tongue_winking_eye"
    },
    {
        "emoji": "😝",
        "title": "stuck_out_tongue_closed_eyes"
    },
    {
        "emoji": "😛",
        "title": "stuck_out_tongue"
    },
    {
        "emoji": "😳",
        "title": "flushed"
    },
    {
        "emoji": "😁",
        "title": "grin"
    },
    {
        "emoji": "😔",
        "title": "pensive"
    },
    {
        "emoji": "😌",
        "title": "relieved"
    },
    {
        "emoji": "😒",
        "title": "unamused"
    },
    {
        "emoji": "😞",
        "title": "disappointed"
    },{
        "emoji": "😣",
        "title": "persevere"
    },
    {
        "emoji": "😢",
        "title": "cry"
    },
    {
        "emoji": "😂",
        "title": "joy"
    },
    {
        "emoji": "😭",
        "title": "sob"
    },
    {
        "emoji": "😪",
        "title": "sleepy"
    },{
        "emoji": "😣",
        "title": "persevere"
    },
    {
        "emoji": "😢",
        "title": "cry"
    },
    {
        "emoji": "😂",
        "title": "joy"
    },
    {
        "emoji": "😭",
        "title": "sob"
    },
    {
        "emoji": "😪",
        "title": "sleepy"
    },
    {
        "emoji": "😥",
        "title": "disappointed_relieved"
    },
    {
        "emoji": "😰",
        "title": "cold_sweat"
    },
    {
        "emoji": "😅",
        "title": "sweat_smile"
    },
    {
        "emoji": "😓",
        "title": "sweat"
    },
    {
        "emoji": "😩",
        "title": "weary"
    },
    {
        "emoji": "😫",
        "title": "tired_face"
    },
    {
        "emoji": "😨",
        "title": "fearful"
    },
    {
        "emoji": "😱",
        "title": "scream"
    },
    {
        "emoji": "😠",
        "title": "angry"
    },
    {
        "emoji": "😡",
        "title": "rage"
    },
    {
        "emoji": "😤",
        "title": "triumph"
    },
    {
        "emoji": "😖",
        "title": "confounded"
    },
    {
        "emoji": "😆",
        "title": "laughing"
    },
    {
        "emoji": "😋",
        "title": "yum"
    },
    {
        "emoji": "😷",
        "title": "mask"
    },
    {
        "emoji": "😎",
        "title": "sunglasses"
    },
    {
        "emoji": "😴",
        "title": "sleeping"
    },
    {
        "emoji": "😵",
        "title": "dizzy_face"
    },
    {
        "emoji": "😲",
        "title": "astonished"
    },
    {
        "emoji": "😟",
        "title": "worried"
    },
    {
        "emoji": "😦",
        "title": "frowning"
    },
    {
        "emoji": "😧",
        "title": "anguished"
    },
    {
        "emoji": "👿",
        "title": "imp"
    },
    {
        "emoji": "😮",
        "title": "open_mouth"
    },
    {
        "emoji": "😬",
        "title": "grimacing"
    },
    {
        "emoji": "😐",
        "title": "neutral_face"
    },
    {
        "emoji": "😕",
        "title": "confused"
    },
    {
        "emoji": "😯",
        "title": "hushed"
    },
    {
        "emoji": "😏",
        "title": "smirk"
    },
    {
        "emoji": "😑",
        "title": "expressionless"
    },
    {
        "emoji": "👲",
        "title": "man_with_gua_pi_mao"
    },
    {
        "emoji": "👳",
        "title": "man_with_turban"
    },
    {
        "emoji": "👮",
        "title": "cop"
    },
    {
        "emoji": "👷",
        "title": "construction_worker"
    },
    {
        "emoji": "💂",
        "title": "guardsman"
    },
    {
        "emoji": "👶",
        "title": "baby"
    },
    {
        "emoji": "👦",
        "title": "boy"
    },
    {
        "emoji": "👧",
        "title": "girl"
    },
    {
        "emoji": "👨",
        "title": "man"
    },
    {
        "emoji": "👩",
        "title": "woman"
    },
    {
        "emoji": "👴",
        "title": "older_man"
    },
    {
        "emoji": "👵",
        "title": "older_woman"
    },
    {
        "emoji": "👱",
        "title": "person_with_blond_hair"
    },
    {
        "emoji": "👼",
        "title": "angel"
    },
    {
        "emoji": "👸",
        "title": "princess"
    },
    {
        "emoji": "😺",
        "title": "smiley_cat"
    },
    {
        "emoji": "😸",
        "title": "smile_cat"
    },
    {
        "emoji": "😻",
        "title": "heart_eyes_cat"
    },
    {
        "emoji": "😽",
        "title": "kissing_cat"
    },
    {
        "emoji": "😼",
        "title": "smirk_cat"
    },
    {
        "emoji": "🙀",
        "title": "scream_cat"
    },
    {
        "emoji": "😿",
        "title": "crying_cat_face"
    },
    {
        "emoji": "😹",
        "title": "joy_cat"
    },
    {
        "emoji": "😾",
        "title": "pouting_cat"
    },
    {
        "emoji": "👹",
        "title": "japanese_ogre"
    },
    {
        "emoji": "👺",
        "title": "japanese_goblin"
    },
    {
        "emoji": "🙈",
        "title": "see_no_evil"
    },
    {
        "emoji": "🙉",
        "title": "hear_no_evil"
    },
    {
        "emoji": "🙊",
        "title": "speak_no_evil"
    },
    {
        "emoji": "💀",
        "title": "skull"
    },
    {
        "emoji": "👽",
        "title": "alien"
    },
    {
        "emoji": "💩",
        "title": "hankey"
    },
    {
        "emoji": "🔥",
        "title": "fire"
    },
    {
        "emoji": "✨",
        "title": "sparkles"
    },
    {
        "emoji": "🌟",
        "title": "star2"
    },
    {
        "emoji": "💫",
        "title": "dizzy"
    },
    {
        "emoji": "💥",
        "title": "boom"
    },
    {
        "emoji": "💢",
        "title": "anger"
    },
    {
        "emoji": "💦",
        "title": "sweat_drops"
    },
    {
        "emoji": "💧",
        "title": "droplet"
    },
    {
        "emoji": "💤",
        "title": "zzz"
    },
    {
        "emoji": "💨",
        "title": "dash"
    },
    {
        "emoji": "👂",
        "title": "ear"
    },
    {
        "emoji": "👀",
        "title": "eyes"
    },
    {
        "emoji": "👃",
        "title": "nose"
    },
    {
        "emoji": "👅",
        "title": "tongue"
    },
    {
        "emoji": "👄",
        "title": "lips"
    },
    {
        "emoji": "👍",
        "title": "thumbs_up"
    },
    {
        "emoji": "👎",
        "title": "-1"
    },
    {
        "emoji": "👌",
        "title": "ok_hand"
    },
    {
        "emoji": "👊",
        "title": "facepunch"
    },
    {
        "emoji": "✊",
        "title": "fist"
    },
    {
        "emoji": "👋",
        "title": "wave"
    },
    {
        "emoji": "✋",
        "title": "hand"
    },
    {
        "emoji": "👐",
        "title": "open_hands"
    },
    {
        "emoji": "👆",
        "title": "point_up_2"
    },
    {
        "emoji": "👇",
        "title": "point_down"
    },
    {
        "emoji": "👉",
        "title": "point_right"
    },
    {
        "emoji": "👈",
        "title": "point_left"
    },
    {
        "emoji": "🙌",
        "title": "raised_hands"
    },
    {
        "emoji": "🙏",
        "title": "pray"
    },
    {
        "emoji": "👏",
        "title": "clap"
    },
    {
        "emoji": "💪",
        "title": "muscle"
    },
    {
        "emoji": "🚶",
        "title": "walking"
    },
    {
        "emoji": "🏃",
        "title": "runner"
    },
    {
        "emoji": "💃",
        "title": "dancer"
    },
    {
        "emoji": "👫",
        "title": "couple"
    },
    {
        "emoji": "👪",
        "title": "family"
    },
    {
        "emoji": "💏",
        "title": "couplekiss"
    },
    {
        "emoji": "💑",
        "title": "couple_with_heart"
    },
    {
        "emoji": "👯",
        "title": "dancers"
    },
    {
        "emoji": "🙆",
        "title": "ok_woman"
    },
    {
        "emoji": "🙅",
        "title": "no_good"
    },
    {
        "emoji": "💁",
        "title": "information_desk_person"
    },
    {
        "emoji": "🙋",
        "title": "raising_hand"
    },
    {
        "emoji": "💆",
        "title": "massage"
    },
    {
        "emoji": "💇",
        "title": "haircut"
    },
    {
        "emoji": "💅",
        "title": "nail_care"
    },
    {
        "emoji": "👰",
        "title": "bride_with_veil"
    },
    {
        "emoji": "🙎",
        "title": "person_with_pouting_face"
    },
    {
        "emoji": "🙍",
        "title": "person_frowning"
    },
    {
        "emoji": "🙇",
        "title": "bow"
    },
    {
        "emoji": "🎩",
        "title": "tophat"
    }
];

export const Emoji = (props) => {
  return <div className="intercom-composer-popover intercom-composer-emoji-popover active">
    <div className="emoji-right mt--10" onClick={props.closeEmojiContainer}>
        <a href="javascript:void(0)" className="text-white font-16 padding-6 text-decoration-none">×</a>
    </div>
      <div className="intercom-emoji-picker">
         <div className="intercom-composer-popover-body-container">
            <div className="intercom-composer-popover-body">
               <div className="intercom-emoji-picker-groups">
                  <div className="intercom-emoji-picker-group">
                    {
                        emojiArr.map((em, key) => 
                        <span key={key} className="intercom-emoji-picker-emoji" onClick={props.emojiSelected} title={em.title}>{em.emoji}</span>
                        )
                    }                
                  </div>               
               </div>
            </div>
         </div>
      </div>
      <div className="intercom-composer-popover-caret"></div>
    </div>
}